import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import * as styles from "../styles/carousel.module.css"


export default function CarouselComponentUpcoming() {

    return (
        <Carousel autoplay={true} infinteLoop={true} interval={1000} showThumbs={false} showArrows={false} showStatus={false}>
            <center>
                {/* 500 height x 300 height */}
                <img src="images/upcoming/1.png" alt="sample" className={styles.images} />
            </center>
            <center>
                <img src="images/upcoming/2.png" alt="sample" className={styles.images} />
            </center>
            <center>
                <img src="images/upcoming/3.png" alt="sample" className={styles.images} />
            </center>
        </Carousel>
    )
}
